// extracted by mini-css-extract-plugin
export default {"timeslot_Column":"timeslot-table--timeslot_Column"};